import { ArrowUpRightIcon } from 'zudoku/icons';

import { LanguagePicker } from './LanguagePicker';

/** Top-right of the header (desktop): the language switch and the way back into the product. */
export const HeaderActions = () => (
  <div className="flex items-center gap-2">
    <LanguagePicker />
    <a
    href="https://app.wearenoe.fr"
    className="noe-header-cta inline-flex items-center gap-1.5 rounded-full bg-primary px-4 h-9 text-sm font-semibold text-primary-foreground shadow-sm transition hover:brightness-95 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary whitespace-nowrap"
  >
    {/* The brand stays « Noé » in every language (Google turned it into « Noah »). */}
    Se connecter à{' '}
    <span className="notranslate" translate="no">
      Noé
    </span>
    <ArrowUpRightIcon size={15} strokeWidth={2.25} aria-hidden="true" />
    </a>
  </div>
);
